export const SIMPLE_SEGMENT_MAP: Record<string, string> = {
  SegmentAnonymousATK: 'Anonymous',
  SegmentAnonymousCCO: 'Anonymous',
  SegmentAnonymousCIO: 'Anonymous',
  SegmentAnonymousSchool: 'Anonymous',
  SegmentRegistrantATK: 'Registrant',
  SegmentRegistrantCCO: 'Registrant',
  SegmentRegistrantCIO: 'Registrant',
  SegmentFreeTrialATK: 'TrialMember',
  SegmentFreeTrialCCO: 'TrialMember',
  SegmentFreeTrialCIO: 'TrialMember',
  SegmentStandardMemberATK: 'Member',
  SegmentStandardMemberCCO: 'Member',
  SegmentStandardMemberCIO: 'Member',
  SegmentPremiumMemberATK: 'Member',
  SegmentPremiumMemberCIO: 'Member',
  SegmentPremiumMemberCCO: 'Member',
  SegmentStandardOtherATK: 'Member',
  SegmentStandardOtherCCO: 'Member',
  SegmentStandardOtherCIO: 'Member',
  SegmentCanceledMemberATK: 'Canceled',
  SegmentCanceledMemberCCO: 'Canceled',
  SegmentCanceledMemberCIO: 'Canceled',
  SegmentCanceledOtherATK: 'Canceled',
  SegmentCanceledOtherCCO: 'Canceled',
  SegmentCanceledOtherCIO: 'Canceled',
  SegmentMultiSite: 'Member',
  SegmentAnonymousLoggedInATK: 'Anonymous',
  SegmentAnonymousLoggedInCCO: 'Anonymous',
  SegmentAnonymousLoggedInCIO: 'Anonymous',
  SegmentRegistrantWithMagATK: 'RegistrantWithMag',
  SegmentRegistrantWithMagCCO: 'RegistrantWithMag',
  SegmentRegistrantWithMagCIO: 'RegistrantWithMag',
  SegmentCanceledOtherWithMagATK: 'CanceledWithMag',
  SegmentCanceledOtherWithMagCCO: 'CanceledWithMag',
  SegmentCanceledOtherWithMagCIO: 'CanceledWithMag',
  SegmentAnonymousLoggedInWithMagATK: 'AnonymousWithMag',
  SegmentAnonymousLoggedInWithMagCCO: 'AnonymousWithMag',
  SegmentAnonymousLoggedInWithMagCIO: 'AnonymousWithMag',
  SegmentAnonymousWithMagATK: 'AnonymousWithMag',
  SegmentAnonymousWithMagCCO: 'AnonymousWithMag',
  SegmentAnonymousWithMagCIO: 'AnonymousWithMag',
  anonymous: 'Anonymous',
  registrant: 'Registrant',
  app_access: 'Multisite',
  multisite: 'Multisite',
  standard_member: 'Multisite',
  standard_other: 'Multisite',
  cancelled_member: 'Canceled',
  cancelled_other: 'Canceled',
  canceled: 'Canceled',
  member: 'Multisite',
  school: 'Registrant',
  registrantWithClasses: 'RegistrantWithClasses',
  canceledWithClasses: 'CanceledWithClasses',
  memberWithClasses: 'MemberWithClasses',
  trialMemberWithClasses: 'TrialMemberWithClasses',
  registrantWithLapsedClasses: 'RegistrantWithLapsedClasses',
  memberWithLapsedClasses: 'MemberWithLapsedClasses',
  trialMemberWithLapsedClasses: 'TrialMemberWithLapsedClasses',
  canceledWithLapsedClasses: 'CanceledWithLapsedClasses',
  trialMember: 'TrialMember',
  registrantWithMag: 'RegistrantWithMag',
  canceledWithMag: 'CanceledWithMag',
  RegistrantWithClasses: 'RegistrantWithClasses',
  MemberWithClasses: 'MemberWithClasses',
  TrialMemberWithClasses: 'TrialMemberWithClasses',
  CanceledWithClasses: 'CanceledWithClasses',
  RegistrantWithLapsedClasses: 'RegistrantWithLapsedClasses',
  MemberWithLapsedClasses: 'MemberWithLapsedClasses',
  TrialMemberWithLapsedClasses: 'TrialMemberWithLapsedClasses',
  CanceledWithLapsedClasses: 'CanceledWithLapsedClasses',
};

export function simpleSegment(segment: string): string {
  return SIMPLE_SEGMENT_MAP[segment] ?? '';
}
